export default "__VITE_ASSET__1b9b58fc__"